import { useCallback, useEffect, useRef } from "react";
import useCatalogUpdates from "./useCatalogUpdates";
import { matchesVendorAvailability, VENDOR_AVAILABILITY_EVENTS } from "../utils/vendorAvailabilityEvents";

export default function useVendorAvailabilityUpdates(query, refresh) {
  const latest = useRef({ query, refresh });
  latest.current = { query, refresh };
  const timerRef = useRef(null);
  const queueRefresh = useCallback(() => {
    if (timerRef.current) return;
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      latest.current.refresh();
    }, 75);
  }, []);
  useEffect(() => () => clearTimeout(timerRef.current), []);
  // Drop an event queued for the previous vendor/outlet on a route change.
  useEffect(() => {
    clearTimeout(timerRef.current);
    timerRef.current = null;
  }, [query?.vendorType, query?.vendorId, query?.outletId]);
  useCatalogUpdates(Object.fromEntries(VENDOR_AVAILABILITY_EVENTS.map((event) => [event, (payload) => {
    if (matchesVendorAvailability(latest.current.query, payload, event)) queueRefresh();
  }])), { enabled: Boolean(query?.vendorType), onConnect: queueRefresh });
}
